import React from 'react'

const Header = () => {
  return (
    <div className="z-1">
        <div className="d-flex justify-content-between align-items-center p-4">
          <h1 className="font-24 font-weight-s-bold m-0">Invoices </h1>
        </div>
      </div>
  )
}

export default Header
